import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Input from '@mui/joy/Input'

export const TextField = ({ label, value, disabled, onChange }) => {
    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <Input
                variant="outlined"
                defaultValue={value}
                onChange={onChange}
            />
        </FormControl>
    )
}
